import { _ } from "../../../../core/polyglot/polyglot.js";
import HtmlEditorDataColumnRenderer from "./HtmlEditorDataColumnRenderer.js";
import HtmlEditorTitleColumnRenderer from "./HtmlEditorTitleColumnRenderer.js";
import ReportVisitor from "../../../../models/reports/reports/ReportVisitor.js";

/**
 * Editor report renderer.
 *
 * Sorting and editing in tables is quite a pain.
 * Instead of going this way, this visitor fakes a table and render nested
 * divs, which is much easier to manipulate.
 *
 * Instead of rendering per row (which is done in the viewer with tr tags),
 * the report is built by column, which makes sorting columns much simpler.
 *
 * @param {report} spec.report - The report
 * @param {function} [spec.onSectionToggled] - Called when a group is
 * expanded or collapsed.
 */
export default class HtmlEditorRenderer extends ReportVisitor {
	constructor({ report, onSectionToggled } = {}) {
		super(...arguments);

		this._report = report;
		this._onSectionToggled = onSectionToggled;
	}

	renderReportOn(html) {
		html.div(
			{ klass: "report-editor" },
			this._renderTitleColumnOn.bind(this),
			html.div(
				{ klass: "draggable column-draggable" },
				this.visitAll(this._report.getColumns()),
			),
		);
	}

	visitAbstractColumn(column) {
		return new HtmlEditorDataColumnRenderer({
			report: this._report,
		}).visit(column);
	}

	visitAbstractPeriodColumn(column) {
		return this.visitAbstractColumn(column);
	}

	_renderTitleColumnOn(html) {
		html.div(
			{ klass: "report-column title-column" },
			html.div(
				{ klass: "report-title column-title" },
				html.span(this._report.getTitle() || _("New report")),
			),
			html.div(
				{ klass: "row-draggable draggable row-droppable" },
				this._report.getRows().map(this._rowTitleRenderer.bind(this)),
			),
		);
	}

	_rowTitleRenderer(row) {
		return new HtmlEditorTitleColumnRenderer({
			report: this._report,
			onSectionToggled: this._onSectionToggled,
		}).visit(row);
	}
}
